<div class="in_vitro_fertilization header_top mb-5">
  <section class="treatment_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Witnessing System</h6>
        <h5>
          Ensuring the Highest Standard of Care at NCare IVF Kannur, Kerala
        </h5>
        <p>
          Ensuring the Highest Standard of Care at NCare IVF Kannur, Kerala
          <br />
          At NCare IVF Kannur, Kerala, we understand that your fertility journey
          is both a personal and emotional experience. That's why we are
          committed to using the most advanced technologies to ensure your
          safety and peace of mind throughout every step of the IVF process. The
          RI Witness electronic witnessing system provides added security and
          minimizes the risk of human error during the IVF cycle. This system
          ensures that you can have complete confidence in the care we provide,
          knowing that every step is meticulously monitored and protected.
        </p>
        <button (click)="contactus()">Book a Consultation</button>
      </div>
    </div>
  </section>

  <section class="mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h5>Minimizing Risks and Ensuring Accuracy</h5>
          <ul>
            <li>
              Fertility treatments are complex, and patients often have concerns
              about processes.
            </li>
            <li>NCare IVF takes steps to minimize errors at every stage.</li>
            <li>
              In addition to clinical and laboratory best practices, the clinic
              uses the RI Witness system to track all samples.
            </li>
            <li>
              The system ensures that every detail is carefully monitored for
              accuracy.
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/witness_sys/minimizing_risks_and_ensuring_accuracy.webp"
            alt=""
          />
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/witness_sys/the_market_leading_art_management_system.webp"
            alt=""
          />
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h5>The Market-Leading ART Management System</h5>
          <ul>
            <li>
              The RI Witness ART Management System is the top electronic
              witnessing solution for IVF clinics globally.
            </li>
            <li>
              It enhances safety and security by tracking eggs, sperm, and
              embryos throughout the IVF cycle.
            </li>
            <li>
              The system records every procedure on your cells, ensuring
              absolute accuracy and security.
            </li>
          </ul>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h5>How RI Witness Works</h5>
          <ul>
            <li>
              Upon registration, each patient is assigned a unique ID code.
            </li>
            <li>
              This ID code is electronically generated and cannot be altered or
              duplicated.
            </li>
            <li>
              The ID is linked to the patient throughout their IVF treatment,
              tracking all samples.
            </li>
            <li>
              Each sample, such as sperm, is tagged with this unique ID to avoid
              mix-ups.
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/witness_sys/how_ri_witness_works.webp"
            alt=""
          />
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/witness_sys/egg_retrieval.webp"
            alt=""
          />
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h5>Egg Retrieval</h5>
          <ul>
            <li>
              During egg retrieval, the RI Witness system ensures security.
            </li>
            <li>
              The patient's ID card is scanned, and only matching samples are
              allowed in the embryology lab.
            </li>
            <li>
              All culture dishes and tubes used in the procedure are labelled
              with special ID tags.
            </li>
            <li>
              The system continuously monitors and records every action to
              maintain safety.
            </li>
          </ul>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h5>Fertilization</h5>
          <ul>
            <li>
              During fertilization, the system ensures eggs and sperm are
              correctly paired.
            </li>
            <li>
              Before the procedure, the system checks the compatibility of the
              ID tags on the eggs and sperm.
            </li>
            <li>
              If any mismatch is detected, the system triggers an alarm to
              prevent errors.
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/witness_sys/fertilization.webp"
            alt=""
          />
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/witness_sys/embryo_transfer.webp"
            alt=""
          />
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h5>Embryo Transfer</h5>
          <ul>
            <li>
              Before the embryo transfer procedure, the system scans the
              patient’s ID card again.
            </li>
            <li>
              It ensures that only the patient’s embryo is used in the transfer.
            </li>
            <li>
              The system links the ID to the allocated work area in the
              embryology lab to guarantee accuracy.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="video_sec mt-5">
    <div class="container">
      <iframe
        src="https://www.youtube.com/embed/jsNpXgZjjNg?si=h7gjfuU5Rs5VrnhQ"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  </section>
  <section class="gold_std_ivf_sec">
    <div class="container">
      <h5>The Gold Standard for IVF Security</h5>
      <p>
        At NCare IVF Kannur, Kerala, we are proud to offer the RI Witness system
        as part of our commitment to providing the highest level of security and
        peace of mind. Recognized as the gold standard in IVF security across
        the globe, RI Witness safeguards every step of your IVF cycle, allowing
        you to focus on your journey with confidence.
      </p>
    </div>
  </section>
</div>
